<script>
  import { afterUpdate } from 'svelte';

  import tippy from 'tippy.js';
  export let photo;
  export let setPhotoDisplayType;
  let tippyInstance;

  let setupTippyWithDelay = function (node) {
    tippyInstance = tippy(node, {
      delay: [1000, 0],
    });
  };

  afterUpdate(() => {
    setTimeout(() => {
      if (tippyInstance) {
        tippyInstance.setContent(photo.display_style == 'contain' ? 'Expand photo' : 'Fit photo');
      }
    }, 100);
  });
</script>

<style style="text/scss" lang="scss">
  .style-icon {
    height: 24px;
    width: 24px;
    position: absolute;
    right: 8px;
    top: 8px;
    display: none;
    cursor: pointer;
    will-change: filter;
    filter: drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 5px);
  }

  .style-icon-wrapper {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 0px;
    position: relative;
  }
</style>

<div class="style-icon-wrapper">
  <img
    data-tippy-content={photo.display_style == 'contain' ? 'Expand photo' : 'Fit photo'}
    use:setupTippyWithDelay
    class="style-icon"
    alt="style-icon"
    on:mousedown|preventDefault|stopPropagation={setPhotoDisplayType()}
    on:touchstart|preventDefault|stopPropagation={setPhotoDisplayType()}
    on:click|preventDefault|stopPropagation
    src={photo.display_style == 'contain'
      ? '/images/rec_request/expand-icon.svg'
      : '/images/rec_request/fit-icon.svg'} />
</div>
